/**
 * ErrorMessage Component
 * Displays error messages with consistent styling
 */

import React from 'react';
import { AlertCircle, X } from 'lucide-react';

const ErrorMessage = ({
  message,
  onClose,
  variant = 'inline',
  title = 'Error'
}) => {
  if (!message) return null;

  const baseClasses = "bg-red-50 border border-red-200 rounded-lg p-4";

  if (variant === 'toast') {
    return (
      <div className="fixed top-4 right-4 max-w-md z-50 animate-slide-in">
        <div className={`${baseClasses} shadow-lg`}>
          <div className="flex items-start gap-3">
            <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <h4 className="font-semibold text-red-800 mb-1">{title}</h4>
              <p className="text-sm text-red-700">{message}</p>
            </div>
            {onClose && (
              <button
                onClick={onClose}
                className="text-red-400 hover:text-red-600 transition-colors"
                aria-label="Close error message"
              >
                <X className="w-5 h-5" />
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={baseClasses}>
      <div className="flex items-start gap-3">
        <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm text-red-700">{message}</p>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="text-red-400 hover:text-red-600 transition-colors"
            aria-label="Close error message"
          >
            <X className="w-5 h-5" />
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;
